import { createFileRoute, Outlet } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

export const Route = createFileRoute('/(main)/invoices/incoming/$invoiceId')({
  component: Outlet,
});

export const INCOMING_INVOICE = buildRouteExport({
  Route,
});
